import { gql } from "@apollo/client"

export const ResignationNoticeFragment = gql`
  fragment ResignationNoticeFragment on Employment {
    resignationNotice {
      duration {
        unit
        value
      }
      type
    }
  }
`

export const ContractedTerminationNoticeFragment = gql`
  fragment ContractedTerminationNoticeFragment on Employment {
    contractedTerminationNotice {
      duration {
        unit
        value
      }
      type
    }
  }
`
